import React, {
  createContext, useContext, useMemo,
} from 'react';
import { useVideos } from './useVideos';

export const VideosContext = createContext(null);

const useUploadVideoContext = () => useContext(VideosContext);

export const useRefetchVideo = () => {
  const { refetchVideo } = useUploadVideoContext();
  return refetchVideo;
};

export function VideosProvider({
  children, initialPageSize, authorId, bookId,
}) {
  const {
    videos,
    isLoading,
    refetchVideo,
    currentPage,
    setCurrentPage,
    totalCount,
    handleSearchSubmit,
    searchTerm,
    currentPageSize,
    setCurrentPageSize,
  } = useVideos(initialPageSize, authorId, bookId);

  const contextValue = useMemo(
    () => ({
      currentPage,
      setCurrentPage,
      totalCount,

      videos,
      isLoading,
      refetchVideo,

      handleSearchSubmit,
      searchTerm,

      currentPageSize,
      setCurrentPageSize,
    }),
    [
      currentPage,
      setCurrentPage,
      totalCount,

      videos,
      isLoading,
      refetchVideo,

      handleSearchSubmit,
      searchTerm,

      currentPageSize,
      setCurrentPageSize,
    ],
  );

  return (
    <VideosContext.Provider value={contextValue}>
      { children }
    </VideosContext.Provider>
  );
}

export const useVideosContext = () => {
  const context = useContext(VideosContext);
  if (!context) {
    throw new Error('useVideosContext must be used within a VideosProvider');
  }
  return context;
};
